export const MicrositeTemplates = {
	tempo: {
		name: "tempo",
		displayName: "Tempo",
		playback: {
			autoplay: true,
			loop: true,
			pauseToShopEnabled: false,
			animateHotspots: true,
			hotspotPulseColor: '#34ace0',
			controlsStyle: "basic",
			scrubBarColor: "#4a90e2",
			viewProductsButton: {
				backgroundColor: "#ffffff",
				textColor: "#1f1f1f",
				style: "pill",
				image: "solid-cart",
				imageSize: 17,
			},
		},
		copyright: "",
		pageTitle: "Shoppable Video",
		button: {
			font: 'Fira Sans',
			style: 'pill',
			color: "#4a90e2",
			textColor: "#ffffff",
		},
		headerHeight: "medium",
		headerText: {
			font: 'Fira Sans',
		},
		bodyText: {
			font: 'Fira Sans',
		},
		backgroundColor: "#ffffff",
		productView: {
			borderRadius: "0px",
			headerBackgroundColor: "#ffffff",
			backgroundColor: "#ffffff",
			variantPickerStyle: 'dropdown',
			addToCart: {
				inline: false,
			},
			header: {
				backgroundColor: "#EDEBE6",
				align: "center",
				titleText: {
					size: 35,
				},
				priceText: {
					size: 16,
				},
			},
		},
		colors: {
			accentColor: "#4a90e2",
		},
		hotspot: {
			icon: "pushCart",
		},
		carousel: {
			products: [],
			itemSize: 'medium',
			headerText: {
				color: "#000000",
				size: 14,
			},
			subheaderText: {
				color: "#8e8e8e",
				size: 13,
			},
		},
		legal: {
			copyright: "",
			privacyUrl: null,
			termsUrl: null,
			cookiesUrl: null
		},
		analytics: {
			facebook: {
				enabled: true,
				fbpixelid: null,
			},
			google: {
				enabled: false,
				trackid: null
			},
			freckle: {
				enabled: true,
			},
			showCookieConsent: false
		},
		header: {
			color: "#ffffff",
			logo: {
				data: "data:image/svg+xml;base64,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",
				size: 30,
				position: 'center',
				href: null
			},
			cart: {
				icon: 'bag5',
				size: 20,
				color: "#000000"
			},
			shadow: true,
		}
	},
	cardboard: {
		name: "cardboard",
		displayName: "Cardboard",
		playback: {
			autoplay: true,
			loop: true,
			pauseToShopEnabled: false,
			animateHotspots: true,
			hotspotPulseColor: '#D0863D',
			controlsStyle: "minimalist",
			scrubBarColor: "#D0863D",
			viewProductsButton: {
				backgroundColor: "#EDEBE6",
				textColor: "#1f1f1f",
				style: "square",
				image: "plus",
				imageSize: 12,
			},
		},
		copyright: "",
		pageTitle: "Shoppable Video",
		button: {
			font: 'Alegreya Sans',
			style: 'square',
			color: "#0f0f0f",
			textColor: "#ffffff",
		},
		headerHeight: "medium",
		headerText: {
			font: 'Alegreya',
		},
		bodyText: {
			font: 'Alegreya Sans',
		},
		backgroundColor: "#EDEBE6",
		productView: {
			borderRadius: "0px",
			backgroundColor: "#EDEBE6",
			variantPickerStyle: 'boxes',
			addToCart: {
				inline: true,
			},
			header: {
				backgroundColor: "#EDEBE6",
				align: "center",
				titleText: {
					size: 35,
				},
				priceText: {
					size: 16,
				},
			},
			photos: {
				arrows: "minimalist",
			},
		},
		colors: {
			accentColor: "#D0863D",
		},
		hotspot: {
			icon: "pushCart",
		},
		carousel: {
			products: [],
			itemSize: 'medium',
			headerText: {
				color: "#000000",
				size: 16,
			},
			subheaderText: {
				color: "#8e8e8e",
				size: 14,
			},
		},
		legal: {
			copyright: "",
			privacyUrl: null,
			termsUrl: null,
			cookiesUrl: null
		},
		analytics: {
			facebook: {
				enabled: true,
				fbpixelid: null,
			},
			google: {
				enabled: false,
				trackid: null
			},
			freckle: {
				enabled: true,
			},
			showCookieConsent: false
		},
		header: {
			color: "#EDEBE6",
			logo: {
				data: "data:image/svg+xml;base64,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",
				size: 22,
				position: 'left',
				href: null
			},
			cart: {
				icon: 'bag4',
				size: 20,
				color: "#000000"
			},
			shadow: false,
		}
	},
	valence: {
		name: "valence",
		displayName: "Valence",
		playback: {
			autoplay: true,
			loop: true,
			pauseToShopEnabled: false,
			animateHotspots: true,
			hotspotPulseColor: '#50c4e3',
			controlsStyle: "minimalist",
			scrubBarColor: "#ff914d",
			viewProductsButton: {
				backgroundColor: "#ffffff",
				textColor: "#1f1f1f",
				style: "square",
				image: "plus",
				imageSize: 14,
			},
		},
		copyright: "",
		pageTitle: "Shoppable Video",
		button: {
			font: 'Lato',
			style: "square",
			color: "#50c4e3",
			textColor: "#ffffff",
		},
		headerHeight: "medium",
		headerText: {
			font: 'Lato',
		},
		bodyText: {
			font: 'Lato',
		},
		backgroundColor: "#ffffff",
		productView: {
			borderRadius: "0px",
			backgroundColor: "#f2fcff",
			variantPickerStyle: 'boxes',
			addToCart: {
				inline: false,
			},
			header: {
				backgroundColor: "#f2fcff",
				align: "left",
				titleText: {
					size: 16,
				},
				priceText: {
					size: 12,
				},
			},
			photos: {
				arrows: "minimalist",
			},
		},
		colors: {
			accentColor: "#D0863D",
		},
		hotspot: {
			icon: "pushCart",
		},
		carousel: {
			fixedSize: true,
			products: [],
			itemSize: 'medium',
			headerText: {
				color: "#000000",
				size: 14,
				weight: '700',
			},
			subheaderText: {
				color: "#8e8e8e",
				size: 12,
				weight: '300',
			},
		},
		legal: {
			copyright: "",
			privacyUrl: null,
			termsUrl: null,
			cookiesUrl: null
		},
		analytics: {
			facebook: {
				enabled: true,
				fbpixelid: null,
			},
			google: {
				enabled: false,
				trackid: null
			},
			freckle: {
				enabled: true,
			},
			showCookieConsent: false
		},
		header: {
			color: "#4ddaff",
			logo: {
				data: "data:image/svg+xml;base64,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",
				size: 40,
				position: 'left',
				href: null
			},
			cart: {
				icon: 'bag7',
				size: 20,
				color: "#000000"
			},
			shadow: true
		}
	},
	minima: {
		name: "minima",
		displayName: "Minima",
		playback: {
			autoplay: true,
			loop: true,
			pauseToShopEnabled: false,
			animateHotspots: true,
			hotspotPulseColor: '#34ace0',
			controlsStyle: "minimalist",
			scrubBarColor: "#000000",
			viewProductsButton: {
				backgroundColor: "#ffffff",
				textColor: "#1f1f1f",
				style: "pill",
				image: "plus",
				imageSize: 17,
			},
		},
		copyright: "",
		pageTitle: "Shoppable Video",
		button: {
			font: 'Roboto',
			style: 'square',
			color: "#000000",
			textColor: "#ffffff",
		},
		headerHeight: "medium",
		headerText: {
			font: 'Roboto',
		},
		bodyText: {
			font: 'Roboto',
		},
		backgroundColor: "#ffffff",
		productView: {
			borderRadius: "0px",
			headerBackgroundColor: "#ffffff",
			backgroundColor: "#ffffff",
			variantPickerStyle: 'dropdown',
			addToCart: {
				inline: false,
			},
			bodyText: {
				weight: 300,
				size: 13,
			},
			header: {
				backgroundColor: "#EDEBE6",
				align: "center",
				titleText: {
					size: 20,
				},
				priceText: {
					size: 12,
				},
			},
			photos: {
				arrows: "minimalist2",
			},
		},
		colors: {
			accentColor: "#000",
		},
		hotspot: {
			icon: "pushCart",
		},
		carousel: {
			products: [],
			itemSize: 'medium',
			headerText: {
				color: "#000000",
				size: 13,
				weight: 500,
			},
			subheaderText: {
				color: "#000000",
				size: 12,
				weight: 500,
			},
		},
		legal: {
			copyright: "",
			privacyUrl: null,
			termsUrl: null,
			cookiesUrl: null
		},
		analytics: {
			facebook: {
				enabled: true,
				fbpixelid: null,
			},
			google: {
				enabled: false,
				trackid: null
			},
			freckle: {
				enabled: true,
			},
			showCookieConsent: false
		},
		header: {
			color: "#ffffff",
			logo: {
				data: "data:image/svg+xml;base64,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",
				size: 17,
				position: 'center',
				href: null
			},
			cart: {
				icon: 'bag7',
				size: 15,
				color: "#000000",
				badgeBorderRadius: 0,
			},
			shadow: false,
		}
	},

	sparrow: {
		name: "sparrow",
		displayName: "Sparrow",
		playback: {
			autoplay: true,
			loop: true,
			pauseToShopEnabled: false,
			animateHotspots: true,
			hotspotPulseColor: '#C2464E',
			controlsStyle: "basic",
			scrubBarColor: "#C2464E",
			viewProductsButton: {
				backgroundColor: "#ffffff",
				textColor: "#1f1f1f",
				style: "rounded",
				image: "plus",
				imageSize: 17,
			},
		},
		copyright: "",
		pageTitle: "Shoppable Video",
		button: {
			font: 'Actor',
			style: 'rounded',
			color: "#C2464E",
			textColor: "#ffffff",
		},
		headerHeight: "medium",
		headerText: {
			font: 'Battambang',
		},
		bodyText: {
			font: 'Actor',
		},
		backgroundColor: "#ffffff",
		productView: {
			borderRadius: "0px",
			headerBackgroundColor: "#ffffff",
			backgroundColor: "#ffffff",
			variantPickerStyle: 'dropdown-rounded',
			addToCart: {
				inline: true,
			},
			bodyText: {
				weight: 300,
				size: 14,
			},
			header: {
				backgroundColor: "#eeeeee",
				align: "center",
				titleText: {
					size: 20,
				},
				priceText: {
					size: 14,
					weight: '700',
					color: "#C2464E"
				},
			},
			photos: {
				arrows: "minimalist",
			},
		},
		colors: {
			accentColor: "#000",
		},
		hotspot: {
			icon: "pushCart",
		},
		carousel: {
			products: [],
			itemSize: 'medium',
			headerText: {
				color: "#000",
				size: 14,
				weight: 700,
			},
			subheaderText: {
				color: "#C2464E",
				size: 13,
				weight: 500,
			},
		},
		legal: {
			copyright: "",
			privacyUrl: null,
			termsUrl: null,
			cookiesUrl: null
		},
		analytics: {
			facebook: {
				enabled: true,
				fbpixelid: null,
			},
			google: {
				enabled: false,
				trackid: null
			},
			freckle: {
				enabled: true,
			},
			showCookieConsent: false
		},
		header: {
			color: "#ffffff",
			logo: {
				data: "data:image/svg+xml;base64,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",
				size: 40,
				position: 'left',
				href: null
			},
			cart: {
				icon: 'bag6',
				size: 20,
				color: "#000000",
				badgeBorderRadius: 0,
			},
			shadow: false,
		}
	},



	
}